export default __webpack_public_path__ + "static/android-chrome-192x192-27e45f3ac0fa01ba8917e06ed9f1409d.png";